import { menuItemClasses as muiMenuItemClasses } from '@mui/material';

export const menuItemClasses = {
  ...muiMenuItemClasses,
  rightContent: 'MenuItem-rightContent',
};
